import React from "react";
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  DateField,
  EditButton,
  DeleteButton
} from 'react-admin';

const UserList = (props) => {
  return (
    <List {...props} title="Usuarios Registrados" bulkActionButtons={false}>
      <Datagrid rowClick="edit" bulkActionButtons>

        <TextField source="firstName" label="Nombre" />
        <TextField source="lastName" label="Apellido" />
        <EmailField source="email" label="Correo Electrónico" />
        <TextField source="phone" label="Celular" />
        <TextField source="role.name" label="Rol" /> 
        <DateField source="createdAt" label="Fecha de registro" />
        <EditButton />
        <DeleteButton/>
      </Datagrid>
    </List>
  );
};

export default UserList;